import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import React from 'react';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

type ImageGridProps = {
  images: { label?: string; url: string; id?: number }[];
  title: React.ReactNode;
  handleDelete?: (id: number) => void;
};

const ImageGrid = ({ images, title, handleDelete }: ImageGridProps) => {
  return (
    <Box mt={24}>
      {title}
      <Flex
        gap={16}
        mt={16}
        flexDir="row"
        flexWrap="wrap"
        className={grid({ columns: 2 })}
      >
        {images?.map((image, index) => (
          <Box
            key={image.url}
            minW={146}
            flex={index === images.length - 1 ? 'unset' : 1}
          >
            <ImageCard
              extension={
                handleDelete
                  ? {
                      type: 'delete',
                      onDeletePhotoHandler: () => handleDelete(image?.id!),
                    }
                  : undefined
              }
              imageData={{
                name: image?.label || `تصویر ${index + 1}`,
                src: image.url,
              }}
            />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default ImageGrid;
